import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, TextField } from '@mui/material';
import React, { FC, useEffect } from 'react';
import styles from './ProjectDialog.module.css';
import { Close } from '@mui/icons-material';
import { useForm } from 'react-hook-form';

interface ProjectDialogProps {
    open: boolean,
    setOpen: (open: boolean) => void,
    setProjectName: (name: string) => void,
}

const ProjectDialog: FC<ProjectDialogProps> = ({ open, setOpen, setProjectName }) => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm<{ projectName: string }>();

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        if(open){
            reset({ projectName: '' })
        }
    }, [open])

    const onSubmit = (data) => {
        setProjectName(data.projectName);
        setOpen(false);
    }

    return (<div>
        <Dialog fullWidth={true} maxWidth="sm" open={open} onClose={handleClose}>
            <DialogTitle>
                <IconButton onClick={handleClose} className={styles.close} color="secondary" data-testid="close-dialog" aria-label="Dialog dicht" component="span">
                    <Close />
                </IconButton>
                <span className={styles.title}>Project</span>
            </DialogTitle>
            <DialogContent>
                <form className={styles.projectForm} data-testid="project-name-form" onSubmit={handleSubmit(onSubmit)}>
                    <h2>Hoe heet uw project?</h2>
                    <div className={styles.subtitle}>
                        (bijv. herontwikkeling Gouda)
                    </div>
                    <div>
                        <TextField id="project-name-password"
                            fullWidth
                            variant="outlined"
                            className="form-input"
                            label="Project Naam"
                            placeholder="herontwikkeling Gouda"
                            {...register('projectName', { required: { value: true, message: 'U moet project naam invullen.' }, maxLength: { value: 255, message: 'Project naam is te lang.' } })}
                        />
                        {errors.projectName && <p className="input-error">{errors.projectName.message}</p>}
                    </div>

                </form>
            </DialogContent>
            <DialogActions>
                <div className={styles.next}>
                    <Button color="primary" data-testid="project-name-submit" size="small" variant="contained" onClick={handleSubmit((d) => onSubmit(d))} >Volgende</Button>
                </div>
            </DialogActions>
        </Dialog>
    </div>
    )
};

export default ProjectDialog;

